import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const COPY_SETTING_DETAILS = `${API_URL}/api/v1/parent/copy-settings`;

export function copySettingDetails(payload) {
  return axiosInstance({
    url: COPY_SETTING_DETAILS,
    method: "POST",
    data: payload,
  });
}
